export const MY_PROFILE_HEADER = 'My Profile';